declare namespace $ {

	type $mol_view__sub_shm_ba_file_picker_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_ba_file_picker_2 = $mol_type_enforce<
		ReturnType< $shm_ba_file_picker['rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $shm_ba_file_picker_file_button__title_shm_ba_file_picker_3 = $mol_type_enforce<
		ReturnType< $shm_ba_file_picker['local_file_title'] >
		,
		ReturnType< $shm_ba_file_picker_file_button['title'] >
	>
	type $shm_ba_file_picker_file_button__current_shm_ba_file_picker_4 = $mol_type_enforce<
		ReturnType< $shm_ba_file_picker['local_file_current'] >
		,
		ReturnType< $shm_ba_file_picker_file_button['current'] >
	>
	type $shm_ba_file_picker_file_button__click_shm_ba_file_picker_5 = $mol_type_enforce<
		ReturnType< $shm_ba_file_picker['local_file_pick'] >
		,
		ReturnType< $shm_ba_file_picker_file_button['click'] >
	>
	type $mol_button_minor__hint_shm_ba_file_picker_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_ba_file_picker_7 = $mol_type_enforce<
		ReturnType< $shm_ba_file_picker['local_file_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_ba_file_picker_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_list__rows_shm_ba_file_picker_9 = $mol_type_enforce<
		ReturnType< $shm_ba_file_picker['section_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_ba_file_picker_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_button_open__title_shm_ba_file_picker_11 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_open['title'] >
	>
	type $shm_button_open__accept_shm_ba_file_picker_12 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_open['accept'] >
	>
	type $shm_button_open__multiple_shm_ba_file_picker_13 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_button_open['multiple'] >
	>
	type $shm_button_open__files_shm_ba_file_picker_14 = $mol_type_enforce<
		ReturnType< $shm_ba_file_picker['files'] >
		,
		ReturnType< $shm_button_open['files'] >
	>
	type $mol_list__rows_shm_ba_file_picker_15 = $mol_type_enforce<
		ReturnType< $shm_ba_file_picker['local_file_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_ba_file_picker_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_ba_file_picker_17 = $mol_type_enforce<
		ReturnType< $shm_ba_file_picker['remote_file_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $shm_ba_file_picker_file_button__title_shm_ba_file_picker_18 = $mol_type_enforce<
		ReturnType< $shm_ba_file_picker['remote_file_title'] >
		,
		ReturnType< $shm_ba_file_picker_file_button['title'] >
	>
	type $shm_ba_file_picker_file_button__current_shm_ba_file_picker_19 = $mol_type_enforce<
		ReturnType< $shm_ba_file_picker['remote_file_current'] >
		,
		ReturnType< $shm_ba_file_picker_file_button['current'] >
	>
	type $shm_ba_file_picker_file_button__click_shm_ba_file_picker_20 = $mol_type_enforce<
		ReturnType< $shm_ba_file_picker['remote_file_pick'] >
		,
		ReturnType< $shm_ba_file_picker_file_button['click'] >
	>
	type $mol_string__hint_shm_ba_file_picker_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_ba_file_picker_22 = $mol_type_enforce<
		ReturnType< $shm_ba_file_picker['file_uri'] >
		,
		ReturnType< $mol_string['value'] >
	>
	export class $shm_ba_file_picker extends $mol_pick {
		File_trigger_icon( ): $mol_icon_file
		file_title( ): string
		File_title( ): $mol_view
		File_trigger_more( ): $mol_icon_dots_vertical
		rows( ): readonly(any)[]
		Body( ): $mol_list
		section_rows( id: any): readonly(any)[]
		section_title( id: any): string
		local_file_rows( ): readonly(any)[]
		local_file_title( id: any): string
		local_file_current( id: any): boolean
		local_file_pick( id: any, next?: any ): any
		Local_file_pick( id: any): $shm_ba_file_picker_file_button
		local_file_delete( id: any, next?: any ): any
		Local_file_delete_icon( id: any): $mol_icon_close
		Local_file_delete( id: any): $mol_button_minor
		remote_file_rows( ): readonly(any)[]
		remote_file_title( id: any): string
		remote_file_current( id: any): boolean
		remote_file_pick( id: any, next?: any ): any
		file_uri( next?: string ): string
		app_id( ): string
		file( next?: any ): any
		files( next?: readonly(File)[] ): readonly(File)[]
		local_file_key( next?: string ): string
		pb_files_collection( ): string
		pb_files_field( ): string
		remote_files( ): readonly(any)[]
		remote_files_forced( ): boolean
		trigger_content( ): readonly(any)[]
		bubble_content( ): readonly(any)[]
		Section( id: any): $mol_list
		Section_title( id: any): $mol_view
		File_open( ): $shm_button_open
		Local_files( ): $mol_list
		Local_file( id: any): $mol_view
		Remote_files( ): $mol_list
		Remote_file( id: any): $shm_ba_file_picker_file_button
		File_uri( ): $mol_string
	}
	
	type $mol_view__sub_shm_ba_file_picker_file_button_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_ba_file_picker_file_button extends $mol_button_minor {
		File_icon( ): $mol_icon_file
		Title( ): $mol_view
		click( next?: any ): any
		current( ): boolean
		attr( ): ({ 
			'shm_ba_file_picker_file_current': ReturnType< $shm_ba_file_picker_file_button['current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		sub( ): readonly(any)[]
		event( ): ({ 
			click( next?: ReturnType< $shm_ba_file_picker_file_button['click'] > ): ReturnType< $shm_ba_file_picker_file_button['click'] >,
		})  & ReturnType< $mol_button_minor['event'] >
	}
	
}

//# sourceMappingURL=picker.view.tree.d.ts.map